import React, { Component } from 'react';
import { Form, Modal, Button, message } from 'antd';
import { Message } from 'semantic-ui-react';

import { ACTION_STATUS } from '../../../../utils/ActionStatus';

class DelLicenseModalDialog extends Component {
  componentDidUpdate() {
    const { delLicenseActionStatus } = this.props;
    if (delLicenseActionStatus === ACTION_STATUS.SUCCESS) {
      message.success('Delete License succeeded');
      this.props.initDelLicenseActionStatus();
      this.props.resetDelLicenseModal();
      this.refreshQuery();
    }
    if (delLicenseActionStatus === ACTION_STATUS.ERROR) {
      this.props.initDelLicenseActionStatus();
    }
  }

  refreshQuery = () => {
    const { employee, regulator, showAll } = this.props.licenseQueryFields;
    this.props.loadLicenseInfo({ employee, regulator, showAll });
  };

  submitDelLicense = () => {
    Modal.confirm({
      title: 'Are you sure to delete this record?',
      onOk: () => {
        const { id } = this.props.delLicenseModal.fields;
        this.props.delLicense({ id });
      },
    });
  };

  render() {
    const { delLicenseModal, delLicenseActionStatus } = this.props;
    const { isOpened, respErrMsg } = delLicenseModal;
    const isSubmitLoading = delLicenseActionStatus === ACTION_STATUS.LOGINING;

    return (
      <Modal
        title="Del License"
        centered
        width={420}
        visible={isOpened}
        destroyOnClose={true}
        maskClosable={false}
        onCancel={this.props.resetDelLicenseModal}
        footer={[
          <Button key="close" onClick={this.props.resetDelLicenseModal}>
            Close
          </Button>,
          <Button key="submit" type="primary" loading={isSubmitLoading} onClick={this.submitDelLicense}>
            Submit
          </Button>,
        ]}
      >
        {!!respErrMsg && (
          <Message negative>
            <Message.Header>Response Error Message</Message.Header>
            <p>{respErrMsg}</p>
          </Message>
        )}
      </Modal>
    );
  }
}

const DelLicenseModalDialogForm = Form.create({ name: 'DelLicenseModalDialog' })(DelLicenseModalDialog);

export default DelLicenseModalDialogForm;
